import {IAlert} from "@components/core/Alerts";
import React, {CSSProperties, useEffect, useState} from "react";
import {LocalisedTypography} from "@components/localisation/LocalisedTypography";
import {Fade} from "@components/interface/Fade";
import {COLOURS, THEME} from "@components/core/theme";
import {connect} from "react-redux";
import {update as updateDialog} from "@redux/slices/dialog";
import {Update} from "@redux/slices/base";
import {Game} from "@game/game";

const styles: Record<string, CSSProperties> = {
    ...THEME,
    alert: {
        alignItems: "center",
        backgroundColor: COLOURS.parchment,
        border: `2px solid ${COLOURS.agedBorder}`,
        borderRadius: 8,
        boxShadow: "0 8px 32px rgba(0,0,0,0.45)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        margin: 16,
        maxWidth: 400,
        padding: 16,
        width: "calc(100% - 64px)"
    },
    content: {
        alignItems: "flex-start",
        backgroundColor: COLOURS.overlay,
        display: "flex",
        justifyContent: "center",
        paddingTop: "10vh",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 200
    },
    heading: {
        ...THEME.heading,
        marginBottom: 8
    }
};

const Content: Record<string, string> = {
    play: "HighScoreAlertContentPlay",
    word: "HighScoreAlertContentWord"
};
const Titles: Record<string, string> = {
    daily: "HighScoreAlertWordDaily",
    weekly: "HighScoreAlertWordWeekly",
    monthly: "HighScoreAlertWordMonthly"
};

interface IWordScore {
    word: string
    score: number
    region_id?: number | null
    tile_id?: number | null
}
interface IHighScoreAlert {
    alert: IAlert
    game: Game
    onClose: () => void
    updateDialog: Update
}
function HighScoreAlert({alert, game, onClose, updateDialog}: IHighScoreAlert) {
    const [visible, setVisible] = useState(true);
    const handleBackgroundClick = () => setVisible(false);
    const title = Titles[alert.data.type];
    const content = Content.word;
    const words = alert.data.words as IWordScore[];
    const bestWordObj = words.length ? words.reduce((best, word) => best.score < word.score ? word : best) : undefined;
    const bestWord = bestWordObj?.word ?? "";
    const params = {
        best: bestWord,
        count: alert.data.count,
        player: alert.data.nickname,
        score: alert.data.score
    };
    const handleCardClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (bestWord) {
            onClose();
            const position = bestWordObj?.region_id != null && bestWordObj?.tile_id != null
                ? game.size.getTilePosition({regionId: bestWordObj.region_id, tileId: bestWordObj.tile_id})
                : undefined;
            updateDialog({update: {name: "definition", data: {
                word: bestWord,
                ...(position ? {position: {x: position.x, y: position.y}} : {})
            }}});
        }
    };

    useEffect(() => {
        setTimeout(() => {
            setVisible(false);
        }, 5000);
    }, []);
    return (
        <div onClick={handleBackgroundClick} style={styles.content}>
            <Fade onFadeOut={onClose} visible={visible}>
                <div onClick={handleCardClick} style={{...styles.alert, cursor: bestWord ? "pointer" : undefined}}>
                    <LocalisedTypography content={title} style={styles.heading}/>
                    <LocalisedTypography content={content} params={params}/>
                </div>
            </Fade>
        </div>
    );
}
const connected = connect(() => ({}), {updateDialog})(HighScoreAlert);
export {connected as HighScoreAlert};